import { useTranslation } from 'react-i18next'

import { useInlineNotifications } from '../../../../../../../hooks'
import { useCloseConfirm } from '../../../../../../Form'
import { FormikForm } from '../../../../../../Formik'
import { WidgetFormContainer } from '../../../../../../Widget'
import { useListingProfileContext } from '../../../RentalPortalListingProfile.hooks'
import { useListingProfileBlockSave } from '../../RentalPortalListingProfileExpose.hooks'
import { LISTING_PROFILE_KEY_FACTS_DISCARD_CONFIRMATION_PROPS } from '../RentalPortalListingProfileKeyFactsWidget.constants'
import {
  getListingKeyFactsInitialValues,
  getListingKeyFactsPatchPayload,
  getListingKeyFactsValidationSchema,
} from '../RentalPortalListingProfileKeyFactsWidget.utils.form'

import { RentalPortalListingProfileKeyFactsWidgetFormFields } from './RentalPortalListingProfileKeyFactsWidgetFormFields'

function RentalPortalListingProfileKeyFactsWidgetForm({ onClose, onSuccess }) {
  const { t } = useTranslation()

  const { listingData } = useListingProfileContext()

  const { handleClose, isCloseConfirm, setCloseConfirm } = useCloseConfirm({
    onClose,
  })

  const { handleAddNotification, handleRemoveNotification, notifications } =
    useInlineNotifications()

  const { handleSaveBlock } = useListingProfileBlockSave({
    onClose,
    onRemoveNotification: handleRemoveNotification,
    onSetNotification: handleAddNotification,
  })

  const initialValues = getListingKeyFactsInitialValues(listingData)

  function handleSubmit(values, formikHelpers) {
    handleSaveBlock({
      formikHelpers,
      payload: getListingKeyFactsPatchPayload(values),
      onSuccess,
    })
  }

  return (
    <FormikForm
      Container={WidgetFormContainer}
      containerProps={{
        confirmationProps: LISTING_PROFILE_KEY_FACTS_DISCARD_CONFIRMATION_PROPS,
        isCloseConfirm,
        setCloseConfirm,
        onClose,
      }}
      initialValues={initialValues}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={getListingKeyFactsValidationSchema({
        initialValues,
        t,
      })}
      onSubmit={handleSubmit}
    >
      <RentalPortalListingProfileKeyFactsWidgetFormFields
        isCloseConfirm={isCloseConfirm}
        notifications={notifications}
        onCancel={handleClose}
        onRemoveNotification={handleRemoveNotification}
        onSetNotification={handleAddNotification}
      />
    </FormikForm>
  )
}

export default RentalPortalListingProfileKeyFactsWidgetForm
